import React, { useMemo } from 'react';
import FastImage, { FastImageProps } from '@d11/react-native-fast-image';
import { ImageStyle } from 'react-native';
import { forceHttps } from '../../utils/libs';

type Props = Omit<FastImageProps, 'source'> & {
  uri?: string | null | undefined;
  style?: ImageStyle | ImageStyle[] | any;
  source?: any;
};

const mapResizeMode = (mode: any) => {
  switch (mode) {
    case 'contain':
    case FastImage.resizeMode.contain:
      return FastImage.resizeMode.contain;
    case 'stretch':
    case FastImage.resizeMode.stretch:
      return FastImage.resizeMode.stretch;
    case 'center':
    case FastImage.resizeMode.center:
      return FastImage.resizeMode.center;
    case 'cover':
    case FastImage.resizeMode.cover:
    default:
      return FastImage.resizeMode.cover;
  }
};

const SecureImage: React.FC<Props> = ({
  uri,
  source,
  style,
  resizeMode,
  ...rest
}) => {
  const computedSource = useMemo(() => {
    if (uri && typeof uri === 'string') {
      if (uri.startsWith('http')) {
        return {
          uri: forceHttps(uri),
          cache: FastImage.cacheControl.immutable,
        } as any;
      }
      return { uri } as any;
    }

    // Fall back to passed source prop (local require or already processed)
    return source as any;
  }, [uri, source]);

  return (
    <FastImage
      source={computedSource}
      style={style}
      resizeMode={mapResizeMode(resizeMode)}
      {...rest}
    />
  );
};

export default SecureImage;
